import { api } from "./client";

export const auth = {
  login: (identifier, password) => api.post("/api/auth/login", { identifier, password }, { skipToast: true }),
  me:    () => api.get("/api/auth/me", { skipToast: true }),
  logout:() => api.post("/api/auth/logout"),
  // sprint83 — one-time LITISOFT-mandatory announcement dismissal.
  dismissLitisoftAnnouncement: () => api.post("/api/auth/dismiss-litisoft-announcement"),
};

export const invitations = {
  list:        () => api.get("/api/invitations"),
  create:      (b) => api.post("/api/invitations", b),
  resend:      (id) => api.post(`/api/invitations/${id}/resend`),
  cancel:      (id) => api.delete(`/api/invitations/${id}`),
  verify:      (token) => api.get(`/api/invitations/verify/${token}`, { skipToast: true }),
  accept:      (b) => api.post("/api/invitations/accept", b, { skipToast: true }),
};

export const cases = {
  list:   (params) => api.get("/api/cases", { params }),
  get:    (id)     => api.get(`/api/cases/${id}`),
  create: (body)   => api.post("/api/cases", body),
  update: (id, b)  => api.put(`/api/cases/${id}`, b),
  remove: (id)     => api.delete(`/api/cases/${id}`, { data: { confirm: "ELIMINAR" } }),
  reassign:(id, abogado_id) => api.post(`/api/cases/${id}/reassign`, { abogado_id }),
  reassignInsumo:(id, user_id) => api.post(`/api/cases/${id}/reassign-insumo`, { user_id }),
  flagError: (id, motivo)   => api.post(`/api/cases/${id}/flag-error`, { motivo }),
  approveLateEntry: (id)    => api.post(`/api/cases/${id}/approve-late-entry`),
  myPriority: (params) => api.get("/api/cases/my-priority", { params }),
  uploadDocument: (id, fd) =>
    api.post(`/api/cases/${id}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }),
  deleteDocument: (id, docId) => api.delete(`/api/cases/${id}/documents/${docId}`),
  restoreDocument: (id, docId) => api.post(`/api/cases/${id}/documents/${docId}/restore`),
  replaceDocument: (id, docId, fd) =>
    api.post(`/api/cases/${id}/documents/${docId}/replace`, fd, { headers: { "Content-Type": "multipart/form-data" } }),
  hardDelete: (id, motivo) => api.delete(`/api/cases/${id}`, { data: { confirm: "ELIMINAR", motivo: motivo || null } }),
  softDelete: (id)         => api.post(`/api/cases/${id}/soft-delete`),
  restore:    (id)         => api.post(`/api/cases/${id}/restore`),
  // Sprint 63 — `tipo` qualifies the strict match. Same radicado + same
  // tipo → strict (caller must block). Same radicado + DIFFERENT tipo →
  // warning with reason="cross_actuacion" (legitimate cross-actuación,
  // caller surfaces an informational chip but doesn't block).
  checkDuplicates: (radicado, accionante, tipo) =>
    api.post("/api/cases/check-duplicates", { radicado, accionante, tipo }, { skipToast: true }),
  action: (id, action, payload, notes) =>
    api.post(`/api/cases/${id}/action`, { action, payload, notes }),
  // feature/marcar-contestada.
  marcarContestada: (id, { categoria, notas }) =>
    api.post(`/api/cases/${id}/marcar-contestada`, { categoria, notas: notas || null }),
  // feature/sancion-lifecycle.
  sancionTransition: (id, newEstado) =>
    api.post(`/api/cases/${id}/sancion-transition`, { new_estado: newEstado }),
  // feature/insumo-deficiente.
  marcarInsumoDeficiente: (id, reason) =>
    api.post(`/api/cases/${id}/marcar-insumo-deficiente`, { reason }),
  // feature/case-flags.
  setFlags: (id, body) =>
    api.patch(`/api/cases/${id}/flags`, body),
  // feature/camilo-action-panel.
  timeline: (id) => api.get(`/api/cases/${id}/timeline`),
  // feature/lifecycle-redesign.
  esperandoInsumo: (id) => api.post(`/api/cases/${id}/esperando-insumo`),
  archivar:        (id, body) => api.post(`/api/cases/${id}/archivar`, body || {}),
  // feature/admin-send-back.
  adminSendBackToLawyer: (id, reason) =>
    api.post(`/api/cases/${id}/admin-send-back-to-lawyer`, { reason }),
  // feature/lawyer-historial.
  lawyerHistorial: (params) => api.get("/api/cases/lawyer-historial", { params }),
};

export const paraArchivar = {
  // feature/lifecycle-redesign.
  list:  () => api.get("/api/cases/para-archivar"),
  count: () => api.get("/api/cases/para-archivar", { params: { count_only: 1 }, skipToast: true }),
};

export const personas = {
  search: (q)   => api.get("/api/personas", { params: { q } }),
  get:    (id)  => api.get(`/api/personas/${id}`),
  cases:  (id)  => api.get(`/api/personas/${id}/cases`),
  create: (b)   => api.post("/api/personas", b),
  // feature/persona-edit — partial update; pass only the changed field(s).
  update: (id, b) => api.patch(`/api/personas/${id}`, b),
};

export const insumos = {
  myCounter: () => api.get("/api/insumos/my-counter"),
  // sprint83 — cap status (which capped users are at/over their daily cap).
  capStatus: () => api.get("/api/insumos/cap-status"),
  // feature/insumos-auto-advance.
  nextPending: (excludeId) => api.get("/api/insumos/next-pending", { params: excludeId ? { exclude: excludeId } : {} }),
  // feature/insumos-pipeline.
  pipeline: (mine = true) => api.get("/api/insumos/pipeline", { params: mine ? { mine: 1 } : {} }),
  // feature/insumos-enviados-export — sprint85. Binary .xlsx of team-wide
  // enviados via axios responseType:'blob' (JWT auto-attached by the
  // request interceptor — a raw fetch() would drop auth). Coordinators get
  // the whole team; an optional user_id scopes to one sender.
  exportEnviados: (params) => api.get("/api/insumos/enviados/export.xlsx", {
    params, responseType: "blob", skipToast: true,
  }),
  insumoPdf: (caseId, formData) =>
    api.post(`/api/cases/${caseId}/insumo-pdf`, formData,
      { headers: { "Content-Type": "multipart/form-data" } }),
  expedienteLetter: (caseId) =>
    api.post(`/api/cases/${caseId}/expediente-letter`),
  replaceScreenshot: (caseId, reqId, formData) =>
    api.post(`/api/cases/${caseId}/insumos/${reqId}/replace-screenshot`, formData,
      { headers: { "Content-Type": "multipart/form-data" } }),
  patchSolicitud: (caseId, reqId, body) =>
    api.patch(`/api/cases/${caseId}/insumos/${reqId}/fields`, body),
  regenerateSolicitudPdf: (caseId, reqId) =>
    api.post(`/api/cases/${caseId}/insumos/${reqId}/regenerate-pdf`),
  // feature/insumos-mega — multi-image attachments per solicitud.
  listAttachments:   (caseId, reqId) => api.get(`/api/cases/${caseId}/insumos/${reqId}/attachments`),
  uploadAttachments: (caseId, reqId, fd) =>
    api.post(`/api/cases/${caseId}/insumos/${reqId}/attachments`, fd,
      { headers: { "Content-Type": "multipart/form-data" } }),
  deleteAttachment:  (caseId, reqId, attId) =>
    api.delete(`/api/cases/${caseId}/insumos/${reqId}/attachments/${attId}`),
  reorderAttachments:(caseId, reqId, order) =>
    api.patch(`/api/cases/${caseId}/insumos/${reqId}/attachments/reorder`, { order }),
  attachmentFileUrl: (caseId, reqId, attId) =>
    `/api/cases/${caseId}/insumos/${reqId}/attachments/${attId}/file`,
  // feature/fallos-workflow-inversion.
  handoffToRevisor: (caseId) =>
    api.post(`/api/cases/${caseId}/insumos/handoff-to-revisor`),
  // feature/lawyer-agency-over-insumos.
  skipInsumos:    (caseId, reason) =>
    api.post(`/api/cases/${caseId}/insumos/skip`, { reason: reason || null }),
  requestInsumos: (caseId, reason) =>
    api.post(`/api/cases/${caseId}/insumos/request`, { reason: reason || null }),
  // feature/reparto-insumos-dispatcher.
  markReceived:   (caseId) =>
    api.post(`/api/cases/${caseId}/insumos/mark-received`),
  routeToLawyer:  (caseId, { notes, reason } = {}) =>
    api.post(`/api/cases/${caseId}/insumos/route-to-lawyer`, {
      notes:  notes  || null,
      reason: reason || null,
    }),
};

export const repartoInsumos = {
  queue: () => api.get("/api/reparto-insumos/queue"),
  // feature/post-fallo-routing-bridge — sprint 82.
  postFalloRouteToInsumos: (caseId) =>
    api.post(`/api/cases/${caseId}/post-fallo-route-to-insumos`),
  postFalloArchive: (caseId) =>
    api.post(`/api/cases/${caseId}/post-fallo-archive`),
  postFalloBulkRouteToInsumos: (case_ids) =>
    api.post("/api/cases/post-fallo/bulk-route-to-insumos", { case_ids }),
  postFalloBulkArchive: (case_ids) =>
    api.post("/api/cases/post-fallo/bulk-archive", { case_ids }),
};

// feature/moderation-escalation.
export const moderation = {
  request: (caseId, reason) =>
    api.post(`/api/cases/${caseId}/solicitar-moderacion`, { reason }),
  queue:   () => api.get("/api/moderation/queue"),
  resolve: (id, body) => api.post(`/api/moderation/${id}/resolve`, body),
  pendingCount: () => api.get("/api/moderation/pending-count", { skipToast: true }),
};

// feature/lawyer-specializations.
export const specializations = {
  list:   (userId)        => api.get(`/api/users/${userId}/specializations`),
  set:    (userId, specs) => api.put(`/api/users/${userId}/specializations`, { specializations: specs }),
};

export const notifications = {
  list:    () => api.get("/api/notifications"),
  read:    (id) => api.post(`/api/notifications/${id}/read`),
  readAll: () => api.post("/api/notifications/read-all"),
  // feature/notifications-history.
  history: (params) => api.get("/api/notifications/history", { params }),
};

export const reports = {
  dailyCounters:  (date) => api.get("/api/reports/daily-counters", { params: date ? { date } : {} }),
  recentActivity: (limit = 25, before = null) => api.get("/api/reports/recent-activity", { params: before ? { limit, before } : { limit } }),
  urgentCases:    (params) => api.get("/api/reports/urgent-cases", { params }),
};

export const exportsApi = {
  litisoftPreview: (params) => api.get("/api/exports/litisoft/preview", { params }),
  litisoftJson:    (params) => api.get("/api/exports/litisoft.json", { params }),
  litisoftUrl:     (params) => "/api/exports/litisoft?" + new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([,v]) => v != null && v !== ""))).toString(),
  // feature/remanente-export — Sprint P3. Triggers a binary xlsx
  // download via axios responseType:'blob'. Returns the response
  // (or throws on 4xx with structured payload for the 0-rows case).
  remanente: (start_date, end_date) => api.get("/api/admin/exports/remanente", {
    params: { start_date, end_date },
    responseType: "blob",
    skipToast: true,
  }),
  // feature/remanentes-pendientes — "Remanentes del mes" (casos sin respuesta).
  // NOT the billing REMANENTE above — this is unanswered cases, by deadline side.
  // feature/casos-sin-respuesta-vigentes — params: { mode:'vencidos'|'vigentes', month? }.
  // Vencidos is month-scoped; vigentes defaults to whole-contract (omit month).
  casosSinRespuesta:    (params) => api.get("/api/exports/casos-sin-respuesta", { params }),
  casosSinRespuestaXlsx:(params) => api.get("/api/exports/casos-sin-respuesta.xlsx", { params, responseType: "blob", skipToast: true }),
};

// feature/informes-mensuales-v1 — sprint84.
export const informes = {
  metrics:  (period_start, period_end) => api.get("/api/informes/metrics", { params: { period_start, period_end } }),
  get:      (period_start) => api.get(`/api/informes/${period_start}`),
  put:      (period_start, body) => api.put(`/api/informes/${period_start}`, body),
  // .docx download is handled directly in InformeMensualPanel via
  // api.post with responseType:'blob'.
};

export const users = {
  list:   (params)   => api.get("/api/users", { params }),
  create: (b) => api.post("/api/users", b),
  update: (id,b) => api.put(`/api/users/${id}`, b),
  toggleActive: (id) => api.post(`/api/users/${id}/toggle-active`),
  resetPassword:(id, newPassword) => api.post(`/api/users/${id}/reset-password`, { newPassword }),
  autoResetPassword: (id) => api.post(`/api/admin/users/${id}/auto-reset-password`),
  updatePreferences: (b) => api.patch("/api/users/me/preferences", b),
  sidebarCounts: () => api.get("/api/users/me/sidebar-counts", { skipToast: true }),
  withRoles: () => api.get("/api/users/with-roles"),
  setRoles:  (id, roles) => api.patch(`/api/users/${id}/roles`, { roles }),
  setInsumosConfig: (id, body) => api.patch(`/api/users/${id}/insumos-config`, body),
  insumosCases: (id) => api.get(`/api/users/${id}/insumos-cases`),
};

export const contestaciones = {
  list:    (params) => api.get("/api/contestaciones", { params }),
  create:  (b) => api.post("/api/contestaciones", b),
  update:  (id, b) => api.patch(`/api/contestaciones/${id}`, b),
  billing: (mes) => api.get("/api/contestaciones/billing", { params: { mes } }),
};

export const carpetas = {
  list:           (params) => api.get("/api/carpetas", { params }),
  byCase:         (caseId) => api.get(`/api/carpetas/by-case/${caseId}`, { skipToast: true }),
  create:         (b) => api.post("/api/carpetas", b),
  update:         (id, b) => api.patch(`/api/carpetas/${id}`, b),
  billingSummary: (mes) => api.get("/api/carpetas/billing-summary", { params: { mes } }),
  // feature/carpetas-tracking — sprint79.
  tracking:       (params) => api.get("/api/carpetas/tracking", { params }),
  // feature/carpetas-tracking — addendum #2. mark_as: "hecha" | "cobrada",
  // hecha_por_id optional for attribution override.
  bulkMark:       (case_ids, { observaciones = null, mark_as = "hecha", hecha_por_id = null } = {}) =>
    api.post("/api/carpetas/bulk", { case_ids, observaciones, mark_as, hecha_por_id }),
  markCobrada:    (carpetaId, observaciones) =>
    api.post(`/api/carpetas/${carpetaId}/mark-cobrada`, { observaciones: observaciones || null }),
  bulkMarkCobrada: (carpeta_ids) => api.post("/api/carpetas/bulk/mark-cobrada", { carpeta_ids }),
  // sprint79.1 — flip pagada=true back to false (carpeta row stays).
  revertCobrada:    (carpetaId) => api.post(`/api/carpetas/${carpetaId}/revert-cobrada`),
  bulkRevertCobrada: (carpeta_ids) => api.post("/api/carpetas/bulk/revert-cobrada", { carpeta_ids }),
  revert:         (carpetaId) => api.post(`/api/carpetas/${carpetaId}/revert`),
  usersList:      () => api.get("/api/carpetas/users-list"),
  trackingCsvUrl: (params) => "/api/carpetas/tracking/export.csv?" +
    new URLSearchParams(Object.fromEntries(Object.entries(params || {}).filter(([,v]) => v != null && v !== ""))).toString(),
  // feature/carpetas-phase2-docs — P2.
  getCarpetaDocuments: (caseId) => api.get(`/api/cases/${caseId}/carpeta-documents`, { skipToast: true }),
  uploadCarpetaDoc:    (caseId, type, file, opts = {}) => {
    const fd = new FormData();
    fd.append("type", type);
    fd.append("file", file);
    if (opts.as_carpeta) fd.append("as_carpeta", "1");
    return api.post(`/api/cases/${caseId}/documents`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  // P2.2 change 3 — true replace for carpeta docs. Soft-deletes the
  // prior row and inserts a new one under the same slot.
  replaceCarpetaDoc: (caseId, docId, file, opts = {}) => {
    const fd = new FormData();
    fd.append("file", file);
    if (opts.as_carpeta) fd.append("as_carpeta", "1");
    return api.post(`/api/cases/${caseId}/documents/${docId}/replace`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export const despacho = {
  list:     () => api.get("/api/despacho/documentos"),
  upload:   (fd) => api.post("/api/despacho/documentos", fd, { headers: { "Content-Type": "multipart/form-data" } }),
  remove:   (id) => api.delete(`/api/despacho/documentos/${id}`),
  downloadUrl: (id) => `/api/despacho/documentos/${id}/download`,
};

export const admin = {
  auditoriaDiaria: (fecha) => api.get("/api/admin/auditoria-diaria", { params: fecha ? { fecha } : {} }),
  cleanupTestCases:  () => api.post("/api/admin/maintenance/cleanup-test-cases"),
  cleanupHistory:    (limit = 20) => api.get("/api/admin/maintenance/cleanup-history", { params: { limit } }),
  auditLog:        (params) => api.get("/api/admin/audit-log", { params }),
  auditLogCsvUrl:  (params) => "/api/admin/audit-log.csv?" + new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([,v]) => v != null && v !== ""))).toString(),
  errorCases:      () => api.get("/api/admin/error-cases"),
  restoreErrorCase:(id) => api.post(`/api/admin/error-cases/${id}/restore`),
  lateEntryQueue:  () => api.get("/api/admin/late-entry-queue"),
};

// feature/bot-litisoft — sprint90. Admin-only LITISOFT bot cockpit.
export const bot = {
  reconciliation:    () => api.get("/api/bot/reconciliation"),
  runs:              () => api.get("/api/bot/runs"),
  runDetail:         (id) => api.get(`/api/bot/runs/${id}`),
  createRun:         (body) => api.post("/api/bot/runs", body),
  runControl:        (id, action) => api.post(`/api/bot/runs/${id}/control`, { action }),
  driveRoots:        () => api.get("/api/bot/drive-roots"),
  addDriveRoot:      (body) => api.post("/api/bot/drive-roots", body),
  toggleDriveRoot:   (id, active) => api.patch(`/api/bot/drive-roots/${id}`, { active }),
  // Phase 3 — credential mgmt (status never returns the secret) + worker bundle.
  credentialsStatus: () => api.get("/api/bot/credentials/status"),
  setCredentials:    (body) => api.post("/api/bot/credentials", body),
  // Phase 3 hardening — paired workers + per-worker revocation kill switch.
  workers:           () => api.get("/api/bot/workers"),
  setWorkerRevoked:  (id, revoked) => api.patch(`/api/bot/workers/${id}`, { revoked }),
};
